export default function(sizes) {
	let sizeArray = Array();
	sizeArray = sizes.split(',');
	let size = String(sizeArray[sizeArray.length - 1]);
	return size.trim();
}
